import PageCustomer from "../customers/detail/page-customer.svelte";
import CustomerDashboard from "../dashboards/customer-dashboard/CustomerDashboard.svelte";
import DefaultRedirect from "../defaults/DefaultRedirect.svelte";
import Error from "../defaults/Error.svelte";
import Forbidden from "../defaults/Forbidden.svelte";
import DesignEditor from "../designs/DesignEditor.svelte";
import PageGroupstores from "../groupstores/page-groupstores.svelte";
import PageDocuments from "../projects/documents/page-documents.svelte";
import PageProject from "../projects/edit/page-project.svelte";
import PageNewProject from "../projects/new/page-new-project.svelte";
//import PageProject from "../projects/edit/page-project.svelte";
import PageProjects from "../projects/page-projects.svelte";
import PageSearch from "../searches/page-search.svelte";
import { wrap } from "svelte-spa-router/wrap";

const routes: { [key: string]: any } = {
  "/": DefaultRedirect,
  "/editor": DesignEditor,
  "/gs": PageGroupstores,
  "/gs/:gsId/search": PageSearch,
  "/gs/:gsId/customers": PageProjects,
  "/gs/:gsId/customers/:customerId": wrap({
    component: PageCustomer
    //asyncComponent: () =>import("$src/presentation/customers/detail/page-customer.svelte"),
  }),
  "/gs/:gsId/projects": PageProjects,
  "/gs/:gsId/projects/new": PageNewProject,
  "/gs/:gsId/projects/:projectId": wrap({
    //asyncComponent: () => import("$src/presentation/projects/edit/page-project.svelte"),
      component: PageProject
    // conditions: [(detail) => {
    //     return false;
    // }]
  }),
  "/gs/:gsId/projects/:projectId/cad": wrap({
    component: PageDocuments
    // asyncComponent: () =>
    //   import("$src/presentation/projects/documents/page-documents.svelte"),
  }),
  "/gs/:gsId/projects/:projectId/documents/:documentId?": wrap({
    component: PageDocuments
    // asyncComponent: () =>
    //   import("$src/presentation/projects/documents/page-documents.svelte"),
  }),
  "/gs/:gsId/projects/:projectId/invoices/:invoiceId?": wrap({
    component: PageDocuments
    // asyncComponent: () =>
    //   import("$src/presentation/projects/documents/page-documents.svelte"),
  }),
  "/gs/:gsId/projects/:projectId/pictures/:pictureId?": wrap({
    component: PageDocuments
    // asyncComponent: () =>
    //   import("$src/presentation/projects/documents/page-documents.svelte"),
  }),
  "/gs/:gsId/projects/:projectId/prints": wrap({
    component: PageDocuments
    // asyncComponent: () =>
    //   import("$src/presentation/projects/documents/page-documents.svelte"),
  }),
  "/settings": CustomerDashboard,
  "/error": Error,
  "/forbidden": Forbidden,
};

export default routes;
